/**
 * Spinner Component
 *
 * A loading spinner with configurable size and color.
 */

import React from 'react';
import './Spinner.css';

const SIZES = {
  xs: 16,
  sm: 20,
  md: 32,
  lg: 48,
  xl: 64,
};

const Spinner = ({
  size = 'md',
  color = 'currentColor',
  thickness = 2,
  className = '',
  label = 'Loading...',
  ...props
}) => {
  const sizeValue = typeof size === 'number' ? size : SIZES[size] || SIZES.md;

  return (
    <div
      className={`ds-spinner ${className}`}
      role="status"
      aria-label={label}
      {...props}
    >
      <svg
        className="ds-spinner__svg"
        width={sizeValue}
        height={sizeValue}
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <circle
          className="ds-spinner__track"
          cx="12"
          cy="12"
          r="10"
          stroke="currentColor"
          strokeWidth={thickness}
          strokeOpacity="0.2"
        />
        <circle
          className="ds-spinner__circle"
          cx="12"
          cy="12"
          r="10"
          stroke={color}
          strokeWidth={thickness}
          strokeLinecap="round"
          strokeDasharray="31.416"
          strokeDashoffset="10"
        />
      </svg>
      <span className="ds-spinner__label">{label}</span>
    </div>
  );
};

export default Spinner;
